{ Storage } = require '@trello/storage'
_ = require 'underscore'

MAX_RECENT = 10

class Recents
  _getKey: (type) ->
    "recent_#{ type }"

  add: (type, value) ->
    current = @get(type)
    newValue = _.chain([value, current...])
    .uniq()
    .first(MAX_RECENT)
    .value()

    Storage.set(@_getKey(type), newValue)

  get: (type, count = MAX_RECENT) ->
    _.chain(Storage.get(@_getKey(type)) ? [])
    .compact()
    .first(count)
    .value()

module.exports = new Recents()
